export const ymd = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const latestSixtyDays = (now = new Date()) => {
  const end = new Date(now);
  const start = new Date(end);
  start.setDate(start.getDate() - 59);
  return { startDate: ymd(start), endDate: ymd(end) };
};

export const makeReportFilters = () => ({
  site_id: '', location_id: '', sublocation_id: '', station: '', daypart: '', ...latestSixtyDays(),
});

export const TAB_REQUESTS = {
  Overview: [
    ['ordersByDay', 'orders-by-day'], ['avgBumpTimeByDay', 'avg-bump-time-by-day'],
    ['ordersHeatmap', 'orders-heatmap'], ['itemsData', 'items-summary'],
    ['itemsByDay', 'items-by-day', true], ['ordersList', 'orders-list'],
    ['ordersBumpMinutes', 'orders-bump-minutes'],
  ],
  Orders: [
    ['ordersByDay', 'orders-by-day'], ['ordersHeatmap', 'orders-heatmap'],
    ['ordersByTable', 'orders-by-table'], ['ordersByServer', 'orders-by-server'],
    ['ordersSummary', 'orders-summary'], ['ordersList', 'orders-list'],
    ['ordersItemsCount', 'orders-items-count'], ['ordersBumpMinutes', 'orders-bump-minutes'],
  ],
  Items: [['itemsData', 'items-summary'], ['ordersByDay', 'orders-by-day']],
};
